const $ = require('jquery');

window.$ = window.jQuery = $;
//sweetalert2
window.Swal = require('sweetalert2');
window.bootstrap = require('bootstrap5/dist/js/bootstrap.min');
//form validate
require('jquery-validation/dist/jquery.validate.min');

$('.form-validate').validate();
$('.form-validate-1').validate();

/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: ES
 */

jQuery.extend(jQuery.validator.messages, {
    required: "Este campo es obligatorio.",
    remote: "Por favor, rellena este campo.",
    email: "Por favor, escribe una dirección de correo válida",
    url: "Por favor, escribe una URL válida.",
    date: "Por favor, escribe una fecha válida.",
    dateISO: "Por favor, escribe una fecha (ISO) válida.",
    number: "Por favor, escribe un número entero válido.",
    digits: "Por favor, escribe sólo dígitos.",
    creditcard: "Por favor, escribe un número de tarjeta válido.",
    equalTo: "Por favor, escribe el mismo valor de nuevo.",
    accept: "Por favor, escribe un valor con una extensión aceptada.",
    maxlength: jQuery.validator.format("Por favor, no escribas más de {0} caracteres."),
    minlength: jQuery.validator.format("Por favor, no escribas menos de {0} caracteres."),
    rangelength: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
    range: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1}."),
    max: jQuery.validator.format("Por favor, escribe un valor menor o igual a {0}."),
    min: jQuery.validator.format("Por favor, escribe un valor mayor o igual a {0}.")
});

//reload captcha
$('#reload').click(function () {
    $.ajax({
        type: 'GET',
        url: 'reload-captcha',
        success:function (data){
            $('.captcha span').html(data.captcha);
        }
    });
});

//dropdown language on responsive views
$(document).ready(function (){
   $('.language-responsive li').on("click",function (){
       /*event.preventDefault();*/
       if ($('.language-responsive li').hasClass('active')){
           $('.language-responsive li').removeClass('active');
       }else{
           $('.language-responsive li').addClass('active');
       }
   })
});

/* responsive burger menu */

const burgerMenuToggler = document.querySelector('.burger-menu .toggler');
const burgerIconWrapper = document.querySelector('.menu-lines');
const burgerMenuWrapper = document.querySelector('.burguer-menu-wrapper');
const burgerListItem = document.querySelectorAll('.burger-nav .item');
const burgerSocialListItem = document.querySelectorAll('.social ul .item');
/*console.log(burgerIconWrapper, burgerMenuToggler)*/

burgerMenuToggler.addEventListener('click', () => {
    burgerIconWrapper.classList.toggle('active');
    burgerMenuWrapper.classList.toggle('active');
    let time= 500;
    let timeSocial = 1000
    burgerListItem.forEach((item) =>{
        setTimeout(() =>{
            item.classList.toggle('active');
        },time);
        time=time+100;
    });

    burgerSocialListItem.forEach((item) =>{
        setTimeout(() =>{
            item.classList.toggle('active');
        },timeSocial);
        timeSocial=timeSocial+100;
    });
});
